import { call, put, takeEvery } from "redux-saga/effects";
import {
  sendCode,
  sendCodeSuccess,
  sendCodeFailure,
  checkCode,
  checkCodeSuccess,
  checkCodeFailure
} from "../../actions/CheckCode";
import { sendCodeRequest } from "../../../api/requests";
import { checkCodeRequest } from "../../../api/requests/CheckCode/CheckCode";

import history from "../../../../../common/history";
import * as URLs from "../../../../../common/constants/systemUrls";
import CookieStorageService from "../../../../../common/services/CookieStorageService";

function* sendCodeSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(sendCodeRequest, payload);
    yield put(sendCodeSuccess(response.data));
  } catch (err) {
    yield put(sendCodeFailure(err));
  }
}

function* checkCodeSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(checkCodeRequest, payload);
    const { user } = response.data;
    localStorage.setItem(
      "user",
      JSON.stringify({
        id: user.userId,
        phone: user.phone
      })
    );
    CookieStorageService.setToken(response.data);
    yield put(checkCodeSuccess(response.data));
    history.push("/" + URLs.AUTHORIZATION + "/" + URLs.PROFILES_LIST);
  } catch (err) {
    console.log(err);
    yield put(checkCodeFailure(err));
  }
}

export function* codeWatcher() {
  //Отправляем повторно код
  yield takeEvery(sendCode.toString(), sendCodeSaga);

  //Авторизаться с кодом
  yield takeEvery(checkCode.toString(), checkCodeSaga);
}
